import { Component, OnInit, Input, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { LoadingIndicator as loadingIndicators } from 'src/app/shared/enums/loading.indicators';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Tables } from 'src/app/shared/entities/tables';
import { Location } from '@angular/common';
import { ViewService } from 'src/app/admin/core/services/viewservice';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { IMenuItem } from 'src/app/admin/core/interfaces/IMenu';
import { PATHS } from 'src/app/app-routing.module';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmRemoveComponent } from 'src/app/admin/core/components/dashboard/confirm-remove/confirm-remove.component';
import { environment } from 'src/environments/environment';
import { TemporaryIdService } from 'src/app/shared/services/temporary-id.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { User } from 'src/app/shared/entities/authentication/user';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { TabService } from 'src/app/shared/services/tab.service';
import { AutologoutService } from 'src/app/shared/services/autologout.service';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { TableStateService } from 'src/app/shared/services/table-state.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {
    client: String = environment.client;
    loadingInd: loadingIndicators = loadingIndicators.OPERATOR;
    isExpanded: boolean = false;
    menuList: any = [];
    showSubmenu: boolean = false;
    tabs = new Array<Tables>();
    tab: Tables = new Tables();
    @Input() public value: string;
    isShowing = false;
    widthSideBar = 80;
    grey = 75;
    widthSideBarExpanded = 340;
    widthSideBarCollapsed = 80;
    isExpaned = false;
    subscriptionText = '';
    manualText = '';

    loadCounter = 1;

    anyList: any[];

    tabHistory: any[] = [];

    /*** tables dynamics */
    public tables: Tables[] = [];
    public tables1: Tables[] = [];
    @Input() table: Tables = new Tables();

    disable: boolean = false;

    selected: number = -1;

    lastHovered: number = 0;

    routerSubscription?: Subscription;

    loaded = false;
    user: User;
    tabContainer: Tables[] = [];
    @ViewChild(MatTabGroup) testt: MatTabGroup;

    renderFlag: boolean = true;
    constructor(
        public loadingService: LoadingService,
        public location: Location,
        private temporaryIdService: TemporaryIdService,
        private httpService: HttpclientService,
        private router: Router,
        private dialog: MatDialog,
        private autoLogout: AutologoutService,
        private userService: UserService,
        private vieWService: ViewService,
        private renderer: Renderer2,
        private tabService: TabService,
        private tableStateService: TableStateService
    ) {
        this.hideExtranetHeader();
    }

    hideExtranetHeader() {
        let head = document.getElementById('head-desktop');
        let burger = document.getElementById('head-resp');
        let foot = document.getElementById('footer');
        let downFoot = document.getElementById('down-foot');
        head?.classList.add('hide-element');
        burger?.classList.add('hide-element');
        foot?.classList.add('hide-element');
        downFoot?.classList.add('hide-element');
    }

    async ngOnInit(): Promise<void> {
        this.initDashboard();
        this.loadHome();
        this.listenRouter();

        await this.loadUser(5);
    }

    async loadUser(tries: number) {
        if (tries > 0) {
            let user: any = await this.userService.getCurrentUser();

            if (user.firstname) {
                user.password = '';
                this.user = user;
                this.loaded = true;
            } else {
                setTimeout(async () => {
                    await this.loadUser(tries - 1);
                }, 400);
            }
        } else {
            this.router.navigate([PATHS.logout]);
        }
    }

    initDashboard() {
        let tabs = localStorage.getItem('tabs');
        let tabHistory = localStorage.getItem('tabHistory');

        if (tabs && tabs.split('-').length > 1) {
            this.loadEntities();
        } else {
            localStorage.setItem('tabs', 'accueil');
        }

        if (tabHistory && tabHistory.length > 1) {
            this.tabHistory = JSON.parse(tabHistory);
            this.setLastViewId();
        } else {
            let genId = this.temporaryIdService.generateId();
            let val = { id: genId, tab: 'accueil' };
            this.tabHistory.push(val);
            localStorage.setItem('tabHistory', JSON.stringify([val]));
            this.router.navigate([PATHS.admin, genId]);
        }
    }

    setLastViewId() {
        let tab = this.tabHistory.map((el) => el?.id?.split('-')[1]).sort((a, b) => b - a);
        this.temporaryIdService.idCounter = tab[0];
    }

    loadHome() {
        this.tab.entite = 'accueil';
        this.tab.title = 'Accueil';
        this.tab.isTable = false;
        this.openOnglet(this.tab);
        this.vieWService.saveViews();
    }

    loadEntities() {
        this.httpService
            .getList<IMenuItem>('assets/mock-apis/menu-' + this.client + '.json')
            .subscribe((el: any) => {
                this.menuList = el;
                let arr: any = localStorage.getItem('tabs')?.split('-');
                if (arr) {
                    for (let i = 1; i < arr.length; i++) {
                        let entite: any = this.findEntityInMenu(arr[i]);

                        if (entite) {
                            let table: Tables = new Tables();
                            table.entite = typeof entite == 'string' ? entite : entite.entityName;
                            table.title = entite.text;
                            table.droitTitle = entite.droitTitle;
                            table.isTable = true;
                            table.filresappliques = this.tab.filresappliques;
                            this.openOnglet(table, false);
                        }
                    }

                    this.selectUrlViewId();
                }
            });
    }

    selectUrlViewId() {
        let tabHistory = localStorage.getItem('tabHistory');
        let url = window.location.href;
        let arr = url.split('/');
        let viewId = arr[arr.length - 1];
        if (tabHistory) {
            let el = JSON.parse(tabHistory).find((el: any) => el?.id == viewId);
            let index = this.tables.findIndex((elx: any) => elx.title == el?.tab);
            this.selectTab({ index: index });
        }
    }

    selectLastTab(index: number) {
        this.selected = index;
    }

    listenRouter() {
        let watch = false;
        this.routerSubscription = this.router.events.subscribe((data) => {
            if (data instanceof NavigationStart && data.navigationTrigger == 'popstate') {
                watch = true;
            }
            if (watch && data instanceof NavigationEnd) {
                let urlArray = data.url.split('/');
                let id = urlArray[urlArray.length - 1];
                let el = this.tabHistory.find((el) => el?.id == id);
                if (el) {
                    let tabIndex = this.tables.findIndex(
                        (elx) => elx.title.toLowerCase() == el.tab.toLowerCase()
                    );
                    this.selectLastTab(tabIndex);
                }

                watch = false;
            }
        });
    }

    findEntityInMenu(entityName: string) {
        let ntt = this.menuList.find((el: any) => el.entityName == entityName);
        if (ntt) return ntt;

        for (let i = 0; i < this.menuList.length; i++) {
            let ntt = this.menuList[i].children
                ? this.menuList[i].children.find((el: any) => el.entityName == entityName)
                : undefined;
            if (ntt) return ntt;
        }
    }

    toggle() {
        if (this.widthSideBar == this.widthSideBarExpanded) {
            this.widthSideBar = this.widthSideBarCollapsed;
            this.grey = 75;
        } else {
            this.widthSideBar = this.widthSideBarExpanded;
            this.grey = 323;
        }
        this.isExpaned = !this.isExpaned;
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    }

    changeNameOrTitleAfterSave(tab: any, value: string) {
        const index = this.tables.findIndex((e) => {
            if (e.title === tab.title) {
                e.title = value;
            }
            /* e.title === tab.title*/
        });
    }

    openPrev(tab: any) {
        const index = this.tables.findIndex((e) => e.title === tab.title);
        this.removeTab(index);
        // this.selected = index - 1;
    }

    openOnglet(tab: Tables, select: boolean = true) {
        tab.isExtranet = tab.title == 'Extranet';

        if (tab.entite.includes('dynamic') && tab.entite !== 'dynamic_document_info') {
            tab.isDynamic = true;
        }

        if (tab.entite == 'deconnexion') {
            this.router.navigate([PATHS.logout]);
            return 0;
        }
        if (tab.title !== '' && !this.tables.some((e) => e.title === tab.title)) {
            this.tables.push(tab);
            if (select) this.selected = this.tables.length + 1;
        } else {
            const index = this.tables.findIndex((e) => e.title === tab.title);
            this.selected = index;
        }

        return 0;
    }
    selectTab(event: any) {
        this.selected = event.index;
        this.setTabHist(event);
        this.saveTables();

        setTimeout(() => {
            let element = document.querySelector(
                ".mat-tab-body-content[style*='visibility: hidden']"
            );
            if (element) {
                this.renderer.setStyle(element, 'visibility', 'visible');
                this.renderer.setStyle(element, 'display', 'block');
            }
        }, 500);
    }

    setTabHist(event: any) {
        let el: any;
        if (event.tab) {
            // Convert to string and add null checks before calling toLowerCase()
            const eventTabLabel =
                event?.tab?.textLabel !== null && event?.tab?.textLabel !== undefined
                    ? String(event.tab.textLabel)
                    : null;
            el = this.tabHistory.find((el) => {
                const elTab = el?.tab !== null && el?.tab !== undefined ? String(el.tab) : null;
                if (!elTab || !eventTabLabel) return false;
                return elTab.toLowerCase() === eventTabLabel.toLowerCase();
            });
        }
        if (el?.id) {
            setTimeout(() => {
                this.router.navigate([PATHS.admin, el?.id]);
            }, 300);
        } else {
            let viewid = this.temporaryIdService.generateId();
            if (event.tab) {
                const eventTabLabel =
                    event?.tab?.textLabel !== null && event?.tab?.textLabel !== undefined
                        ? String(event.tab.textLabel)
                        : null;
                if (!el && eventTabLabel) {
                    this.tabHistory.push({ id: viewid, tab: eventTabLabel });
                } else if (el && eventTabLabel) {
                    this.tabHistory = this.tabHistory.map((tab) => {
                        const tabTab =
                            tab.tab !== null && tab.tab !== undefined ? String(tab.tab) : null;
                        const elTab =
                            el?.tab !== null && el?.tab !== undefined ? String(el.tab) : null;
                        if (tabTab === elTab) return { id: viewid, tab: eventTabLabel };
                        return tab;
                    });
                }
            }
            this.router.navigate([PATHS.admin, viewid]);
        }
    }

    saveTables() {
        localStorage.setItem('tabs', this.tables.map((el) => el.entite).join('-'));
        localStorage.setItem('tabHistory', JSON.stringify(this.tabHistory));
    }

    ajouterUnEntite(entite: any) {
        this.openOnglet(entite);
    }

    visualisation(
        title: any,
        entite: any,
        id: any,
        typeName: any = '',
        totalElements: number = 0,
        droitTitle: any = ''
    ) {
        const tab = new Tables();

        if (entite.toLowerCase().includes('dynamic') && entite !== 'dynamic_document_info') {
            tab.isDynamic = true;
        }
        tab.entite = entite;
        tab.title = title;
        tab.droitTitle = droitTitle;

        tab.id = id;
        tab.value = 'lecture';
        tab.typeName = typeName;
        tab.totalElements = totalElements;
        this.table = tab;
        this.openOnglet(this.table);
    }

    onDrop(event: any) {
        moveItemInArray(this.tables, event.previousIndex, this.lastHovered + 1);
        this.tables = [...this.tables];
        // this.tabHistory = this.tables.map((table, index) => {
        //     return { id: this.tabHistory[index]?.id, tab: table.title };
        // });

        this.renderFlag = false;
        setTimeout(() => {
            this.renderFlag = true;
            this.selectTab({ index: this.lastHovered - 1 });
        }, 1);
    }

    onHover(index: number) {
        this.lastHovered = index;
    }

    trackByFn(index: number, tab: any): string {
        return tab.id; // Replace "id" with the unique identifier property of your tab object
    }

    removeTab(index: number) {
        const tab = this.tables[index];
        // Check if tab is in creation mode (title contains "Création")
        const isCreation = tab.title?.toString().includes('Création') || false;

        // Check if user already confirmed close (from cancel button in template-edit component)
        // This prevents double popup when cancel button is clicked
        const alreadyConfirmed = (tab as any).confirmedClose === true;

        // Show confirmation popup for edit mode or creation mode
        // BUT skip popup if already confirmed (from cancel button)
        if ((tab.value == 'edition' || isCreation) && !alreadyConfirmed) {
            let dialogRef = this.dialog.open(ConfirmRemoveComponent, {
                width: '80%',
                maxWidth: '500px',
                data: [tab.title],
            });

            dialogRef.afterClosed().subscribe((resp) => {
                if (resp == 'OK') {
                    // User confirmed: Clear data BEFORE closing tab
                    // This ensures data is only cleared after user confirms in popup
                    if (isCreation && tab.entite) {
                        // For creation mode: clear creation-specific data
                        this.tabService.clearTempEditDataForCreation(tab.entite);
                        this.tabService.clearActiveTabIndexForCreation(tab.entite);
                    } else if (tab.id) {
                        // For edit mode: clear edit-specific data
                        this.tabService.clearTempEditData(tab.id);
                        this.tabService.clearActiveTabIndex(tab.id);
                    }
                    // Data cleared, now close the tab
                    this.closeTab(index);
                } else {
                    // User cancelled popup (resp != 'OK'): do nothing - data remains intact
                    // Tab stays open, user can continue working
                }
            });
        } else {
            // Already confirmed from cancel button OR not in edit/creation mode
            if (alreadyConfirmed) {
                // Data already cleared in performCancel() before calling dash.openPrev()
                // This happens when user clicks Cancel button in creation mode and confirms popup
                // performCancel() already cleared:
                //   - clearTempEditDataForCreation() for creation mode
                //   - clearActiveTabIndexForCreation() for creation mode
                //   - Reset tempData and data
                // So we just need to close the tab, no need to clear data again
                this.closeTab(index);
            } else {
                // Not in edit/creation mode (e.g., read-only tab)
                // Just close the tab without clearing data (no data to clear)
                this.closeTab(index);
            }
        }
    }

    closeTab(index: number) {
        const tabToClose = this.tables[index];
        const tabId = tabToClose?.id;
        const tabTitle = tabToClose?.title;
        const tabEntite = tabToClose?.entite;

        // Clear all states for this entity when closing the tab
        // This ensures that when the tab is reopened, it uses default visualization instead of restoring old state
        if (tabEntite) {
            this.tableStateService.clearStatesForEntity(tabEntite);
        }

        // Remove tab state from tableStateHistory in localStorage
        if (tabId) {
            try {
                const tableStateHistoryStr = localStorage.getItem('tableStateHistory');
                if (tableStateHistoryStr) {
                    const tableStateHistory = JSON.parse(tableStateHistoryStr);
                    const beforeCount = tableStateHistory.length;
                    // IMPORTANT: Convert both to string for strict comparison to avoid type mismatch
                    const tabIdStr = String(tabId);
                    const updatedHistory = tableStateHistory.filter((el: any) => {
                        const elIdStr =
                            el?.id !== null && el?.id !== undefined ? String(el.id) : null;
                        return elIdStr !== tabIdStr;
                    });
                    localStorage.setItem('tableStateHistory', JSON.stringify(updatedHistory));
                }
            } catch (error) {
                console.error('Error removing tab state from tableStateHistory:', error);
            }
        }

        // Remove tab entry from tabHistory to prevent reusing old ID when opening same tab again
        // This ensures that when user opens a tab with the same title, it gets a new ID and doesn't restore old state
        if (tabTitle !== null && tabTitle !== undefined) {
            // Convert tabTitle to string (it might be a number like 628436)
            const tabTitleStr = String(tabTitle);
            this.tabHistory = this.tabHistory.filter((el) => {
                // Remove entry if it matches the closed tab's title
                // This prevents setTabHist() from reusing the old ID when opening the same tab again
                // Convert el.tab to string and compare (both might be numbers or strings)
                const elTab = el?.tab !== null && el?.tab !== undefined ? String(el.tab) : null;
                return !elTab || elTab.toLowerCase() !== tabTitleStr.toLowerCase();
            });
            // Save updated tabHistory to localStorage
            localStorage.setItem('tabHistory', JSON.stringify(this.tabHistory));
        }

        this.tables.splice(index, 1);

        // Update tabHistory indices after removing entry
        // Note: We already filtered tabHistory above, so we need to adjust indices differently
        // Actually, tabHistory is not indexed by array position, it's an array of objects with id and tab
        // So we don't need to adjust indices here

        for (let i = 0; i < this.tabHistory.length; i++) {
            if (this.tabHistory[i] > index) this.tabHistory[i]--;
        }

        //correction pour eviter de retourner à longlet accueil à chaque fois que l'on ferme un onglet
        // this.selected.setValue(this.tabHistory[this.tabHistory.length - 1]);
    }

    editDuplicateRecord(record: any) {
        this.openOnglet(record);
    }

    closeAllTabs() {
        let confirmTabs = this.tables.filter((el) => el.value == 'edition');
        if (confirmTabs.length > 0) {
            let dialogRef = this.dialog.open(ConfirmRemoveComponent, {
                maxWidth: '500px',
                data: confirmTabs.map((el) => el.title),
            });

            dialogRef.afterClosed().subscribe((resp) => {
                if (resp == 'OK') {
                    // Clear all filters and table states (similar to logout)
                    this.clearAllFiltersAndTableStates();
                    
                    localStorage.removeItem('tabs');
                    localStorage.removeItem('tabHistory');
                    this.tables = [];
                    this.tabHistory = [];
                    this.loadHome();
                } else if (resp === 'CANCEL') {
                    this.tables = this.tables.filter((el) => el.value == 'edition');
                    this.loadHome();
                }
            });
        } else {
            // Clear all filters and table states (similar to logout)
            this.clearAllFiltersAndTableStates();
            
            localStorage.removeItem('tabs');
            localStorage.removeItem('tabHistory');
            this.tables = [];
            this.tabHistory = [];
            this.loadHome();
        }
    }

    /**
     * Clear all filters and table states (similar to logout)
     * Called when closing all tabs
     */
    private clearAllFiltersAndTableStates(): void {
        // Clear table state history and table states
        localStorage.removeItem('tableStateHistory');
        this.tableStateService?.clearAllStates();

        // Clear filter-related localStorage items
        localStorage.removeItem('filter');

        // Clear filter-related sessionStorage items
        sessionStorage.removeItem('productFilters');
        sessionStorage.removeItem('redirectNav');

        // Clear all table_state_* keys from sessionStorage (if any remain)
        try {
            const keysToRemove: string[] = [];
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith('table_state_')) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((key) => sessionStorage.removeItem(key));
        } catch (error) {
            console.error('Error clearing table state keys from sessionStorage:', error);
        }
    }

    ngOnDestroy(): void {
        this.routerSubscription?.unsubscribe();
    }
}
